import { MdOutlineLightMode, MdDarkMode } from 'react-icons/md';
import React, { useEffect, useState } from "react";
import { getUser, setUser } from "./Constants/globals";
import axios from "axios";
import { Url } from "./Constants/globals";
import RefreshToken from "./Components/RefreshToken/RefreshToken";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HiOutlineLogout  } from "react-icons/hi";
import './App.css';
import NotFound from "./Pages/404/404";
import stylesModal from "./Components/DeleteModal/deletemodal.module.css"

import Login from "./Pages/Login/login";
import ChangePasswordForm from './Pages/Login/change_password_form';
import ResetPassword from './Pages/Login/reset_password';

import Empresas from "./Pages/Empresas/empresas";
import EditarEmpresas from './Pages/Empresas/EditarEmpresas/editarempresas';

import Menu from "./Pages/Menu/menu";

import Unidades from "./Pages/Unidades/unidades";
import EditarUnidades from './Pages/Unidades/EditarUnidades/editarunidades';

import Utilizadores from "./Pages/Utilizadores/utilizadores";
import LogsUtilizadores from "./Pages/Utilizadores/LogsUtilizadores/logs";

import Funcionarios from "./Pages/Funcionarios/funcionarios";
// import FuncionariosAprovacoes from "./Pages/Funcionarios/Aprovacoes/aprovacoes";
import EditarFuncionarios from "./Pages/Funcionarios/EditarFuncionarios/editarfuncionarios";

import Campanhas from './Pages/Campanhas/campanhas';
import EditarCampanhas from './Pages/Campanhas/EditarCampanhas/editar_campanhas';
// import GruposCampanhas from './Pages/GruposCampanhas/grupos_campanhas';
// import EditarGruposCampanhas from './Pages/GruposCampanhas/EditarGruposCampanhas/editar_grupos_campanhas';

import Protocolos from "./Pages/Protocolos/protocolos";
import ProtocolosCategorias from './Pages/Protocolos/Categorias/categorias';
import EditarProtocolos from "./Pages/Protocolos/EditarProtocolos/editarprotocolos";

import Calendario from "./Pages/Calendario/calendario";

import ComunicacoesInternas from "./Pages/ComunicacoesInternas/comunicacoesinternas";
import EditarComunicacoesInternas from "./Pages/ComunicacoesInternas/EditarComunicacoesInternas/editarcomunicacoesinternas";
import me from './Components/Me/me';
import Cartoes from './Pages/Funcionarios/Cartoes/cartoes';
import EditarCartoes from './Pages/Funcionarios/Cartoes/EditarCartoes/editarcartoes';
import EmpresasCartoes from './Pages/Empresas/Cartoes/empresascartoes';
import EditarEmpresasCartoes from './Pages/Empresas/Cartoes/EditarEmpresasCartoes/editarempresascartoes';

function AppContent() {

  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [hasUser, setHasUser] = useState(false);
  const [userPermissions, setUserPermissions] = useState({});

  async function handleMe(){
    await setLoading(true);
    const permissions = await me();
    setUserPermissions(permissions);
    setLoading(false);
  }

  useEffect(() => {
    if (!localStorage.getItem("user")) {
      return setHasUser(false);
    }
    else {
      handleMe();
      setHasUser(true);
    }
  }, [location.pathname]);

  function pages(){
    if (hasUser && userPermissions){
      return (
        <Routes>
          <Route path="/" element={<Menu userPermissions={userPermissions} />} />
          <Route path="/menu" element={<Menu userPermissions={userPermissions} />} />

          {
            userPermissions?.empresas ?
              <Route path="/empresas" element={<Empresas userPermissions={userPermissions} />} />
            : userPermissions?.cartoes ?
              <Route path="/empresas" element={<EmpresasCartoes userPermissions={userPermissions} />} />
            :""
          }
          { userPermissions?.empresas ? <Route path="/empresas/adicionar" element={<EditarEmpresas userPermissions={userPermissions} />} /> : "" }
          { userPermissions?.empresas ? <Route path="/empresas/:id" element={<EditarEmpresas userPermissions={userPermissions} />} /> : "" }

          { userPermissions?.unidades ? <Route path="/unidades" element={<Unidades userPermissions={userPermissions} />} /> : "" }
          { userPermissions?.unidades ? <Route path="/unidades/adicionar" element={<EditarUnidades userPermissions={userPermissions} />} /> : "" }
          { userPermissions?.unidades ? <Route path="/unidades/:id" element={<EditarUnidades userPermissions={userPermissions} />} /> : "" }

          
          {/* { userPermissions?.colaboradores ? <Route path="/funcionarios/aprovacoes" element={<FuncionariosAprovacoes userPermissions={userPermissions} />} /> : "" } */}
          {
            userPermissions?.colaboradores ?
              <Route path="/colaboradores" element={<Funcionarios userPermissions={userPermissions} />} />
            : userPermissions?.cartoes ?
              <Route path="/colaboradores" element={<Cartoes userPermissions={userPermissions} />} />
            :""
          }
          { userPermissions?.colaboradores ? <Route path="/colaboradores/adicionar" element={<EditarFuncionarios userPermissions={userPermissions} />} /> : "" }
          { userPermissions?.colaboradores ? <Route path="/colaboradores/:id" element={<EditarFuncionarios userPermissions={userPermissions} />} /> : "" }
          { userPermissions?.colaboradores ? <Route path="/utilizadores" element={<Utilizadores userPermissions={userPermissions} />} /> : "" }
          { userPermissions?.colaboradores ? <Route path="/utilizadores/:id/logs" element={<LogsUtilizadores userPermissions={userPermissions} />} /> : "" }

          { userPermissions?.campanhas ? <Route path="/campanhas" element={<Campanhas userPermissions={userPermissions} />} /> : "" }
          { userPermissions?.campanhas ? <Route path="/campanhas/adicionar" element={<EditarCampanhas userPermissions={userPermissions} />} /> : "" }
          { userPermissions?.campanhas ? <Route path="/campanhas/:id" element={<EditarCampanhas userPermissions={userPermissions} />} /> : "" }
          {/* { userPermissions?.campanhas ? <Route path="/campanhas/grupos" element={<GruposCampanhas userPermissions={userPermissions} />} /> : "" }
          { userPermissions?.campanhas ? <Route path="/campanhas/grupos/adicionar" element={<EditarGruposCampanhas userPermissions={userPermissions} />} /> : "" }
          { userPermissions?.campanhas ? <Route path="/campanhas/grupos/:id" element={<EditarGruposCampanhas userPermissions={userPermissions} />} /> : "" } */}

          { userPermissions?.protocolos ? <Route path="/protocolos" element={<Protocolos userPermissions={userPermissions} />} /> : "" }
          { userPermissions?.protocolos ? <Route path="/protocolos-categorias" element={<ProtocolosCategorias userPermissions={userPermissions} />} /> : "" }
          { userPermissions?.protocolos ? <Route path="/protocolos/adicionar" element={<EditarProtocolos userPermissions={userPermissions} />} /> : "" }
          { userPermissions?.protocolos ? <Route path="/protocolos/:id" element={<EditarProtocolos userPermissions={userPermissions} />} /> : "" }

          { userPermissions?.comunicacoes ?<Route path="/comunicacoes-internas" element={<ComunicacoesInternas userPermissions={userPermissions} />} /> : "" }
          { userPermissions?.comunicacoes ? <Route path="/comunicacoes-internas/:id" element={<EditarComunicacoesInternas userPermissions={userPermissions} />} /> : "" }
          { userPermissions?.comunicacoes ? <Route path="/comunicacoes-internas/adicionar" element={<EditarComunicacoesInternas userPermissions={userPermissions} />} /> : "" }
          
          { userPermissions?.eventos ? <Route path="/calendario" element={<Calendario userPermissions={userPermissions} />} /> : ""}

          { userPermissions?.cartoes ? <Route path="/empresas-cartoes" element={<EmpresasCartoes userPermissions={userPermissions} />} /> : "" }
          { userPermissions?.cartoes ? <Route path="/empresas-cartoes/adicionar" element={<EditarEmpresasCartoes userPermissions={userPermissions} />} /> : "" }
          { userPermissions?.cartoes ? <Route path="/empresas-cartoes/:id" element={<EditarEmpresasCartoes userPermissions={userPermissions} />} /> : "" }
          { userPermissions?.cartoes ? <Route path="/cartoes" element={<Cartoes userPermissions={userPermissions} />} /> : "" }
          { userPermissions?.cartoes ? <Route path="/cartoes/adicionar" element={<EditarCartoes userPermissions={userPermissions} />} /> : "" }
          { userPermissions?.cartoes ? <Route path="/cartoes/:slug" element={<EditarCartoes userPermissions={userPermissions} />} /> : "" }
          
          <Route path="*" element={<NotFound />} />
        </Routes>
      )
    }
    else {
      return (
        <Routes>
          <Route path="/" element={<Login />} />
            <Route path="/recover-password" element={<ChangePasswordForm />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      )
    }
  }
  
  return pages();
}

function App() {

  const [theme, setTheme] = useState((localStorage.getItem("user") && localStorage.getItem("user").info) ? JSON.parse(localStorage.getItem("user").info.theme) : localStorage.getItem("theme") ? localStorage.getItem("theme") : "light");
  const [modalLogout, setModalLogout] = useState();

  // Mudança de tema
  const switchTheme = async () => {
    const newTheme = localStorage.getItem("theme") && localStorage.getItem("theme") !== "light" ? "light" : "dark";
    if (JSON.parse(localStorage.getItem("user"))){
      var newUser = JSON.parse(localStorage.getItem("user"));
      newUser.info.theme = newTheme;
      await axios.put(Url + "/users/"+newUser.info.id, {
        headers: {
          Authorization: "Bearer "+getUser().token,
        }
      }, {
        theme: newTheme
      })
      .then(() => {
        localStorage.setItem("user", JSON.stringify(newUser));
        setUser(newUser);
      })
      .catch((err) => {
        if (err.request && err.request.status === 401){
          RefreshToken(err);
        }
        return "error";
      });
    }
    await setTheme(newTheme);
    localStorage.setItem("theme", newTheme);
  }

  const handleLogout = () => {
    localStorage.removeItem("user");
    window.location = "/";
  }

  const ModalLogout = () => {
    const [isPoppedOut, setIsPoppedOut] = useState(false);

    function handleClose() {
      setIsPoppedOut(true);
      setTimeout(() => {
        setModalLogout("");
      }, 250);
    }

    return (
      <div className={`${stylesModal.bodyDelete} ${isPoppedOut ? stylesModal.popout : stylesModal.popin}`}>
        <div className={stylesModal.center}>
          <div className={stylesModal.column}>
            <h4 style={{margin:0}}>Deseja terminar sessão ?</h4>
            <div className={stylesModal.buttons}>
              <button className={stylesModal.actionButton} onClick={() => handleLogout()}>Sim</button>
              <button className={stylesModal.backButton} onClick={() => handleClose()}>Não</button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="App" data-theme={theme}>
      {modalLogout}
      <button className="switchMode" onClick={switchTheme}>
        {theme === "light" ? <MdDarkMode size={20}/> : <MdOutlineLightMode size={20}/>}
      </button>
      <BrowserRouter>
        <AppContent/>
        {
          localStorage.getItem("user") ?
            <div className="logout" onClick={() => setModalLogout(<ModalLogout/>)}>
              <HiOutlineLogout size={30} className="iconLogout"/>
              <p className={"logoutText"}>Sair</p>
            </div>
          : ""
        }
      </BrowserRouter>
    </div>
  );
}

export default App;
